import { Injectable } from '@angular/core';
import { LuigiNode, NodeContext } from '@openmfp/portal-ui-lib';

export const VPN_HANDLING_PATH = '/no-vpn-handling';

@Injectable({
  providedIn: 'root',
})
export class VPNService {
  private inVPN = false;

  setVPN(inVPN: boolean) {
    this.inVPN = inVPN;
  }

  public vpnHandling(node: LuigiNode) {
    return this.inVPN ? node : this.convertToNoVPNHandlingNode(node);
  }

  private convertToNoVPNHandlingNode(originalNode: LuigiNode): LuigiNode {
    const fieldOverwrites: LuigiNode = {
      context: {} as NodeContext,
      viewUrl: VPN_HANDLING_PATH,
      networkVisibility: undefined,
      visibleForPlugin: undefined,
      children: [],
    };
    if (!originalNode.statusBadge) {
      fieldOverwrites.statusBadge = {
        label: 'VPN',
        type: 'informative',
      };
    }
    return Object.assign({}, originalNode, fieldOverwrites);
  }
}
